module.exports = "<div class=\"y-box-sticky-ctn\">\n  <div class=\"y-box-sticky\">\n    <div class=\"row\">\n      <!-- ko if: title -->\n      <div class=\"col-sm-2 y-box-sticky-title\">\n        <span data-bind=\"text:title\"></span>\n      </div>\n      <!-- /ko -->\n      <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/boxsticky/index.html
// module id = 220
// module chunks = 0